import styled from "styled-components"

import { eq, minWidth, maxWidth } from "utils"

import CroppedImage from "components/cropped-image"

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  margin: 0 0 2rem;

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto 4rem;
  `}

  ${minWidth.hamburgerLarge`
    ${eq("priority", 1)`
      width: calc(100% - 8rem);
      max-width: 100%;
      margin: 0 4rem 6rem;
      overflow: hidden;
    `}

    ${eq("priority", 2)`
      max-width: 72.5rem;
      margin: 0 auto 6rem;
    `}

    ${eq("priority", 3)`
      width: 33.33%;
      max-width: 28rem;
      margin: 0 8.33% 2rem;
      display: inline-block;
      float: left;
    `}
  `}
`

export const ImageLink = styled.a`
  display: block;
  background-color: transparent;
`

export const ImageCropped = styled(CroppedImage)`
  padding-top: ${({ imageData }) =>
    imageData.width && imageData.height
      ? `${(imageData.height / imageData.width) * 100}%`
      : "66.66%"};
`

export const Media = styled.div`
  padding-top: 1rem;
  font-size: 1.5rem;
  line-height: 1.1;
  color: ${({ theme }) => theme.colors.primary};

  ${maxWidth.tablet`
    width: calc(100% - 5.4rem);
    margin: 0 2.7rem;
  `}
`

export const Caption = styled.div`
  margin-bottom: 0.5rem;
  font-weight: 500;
`

export const CreditSource = styled.div`
  margin-bottom: 2rem;
  font-style: italic;
`

export const VideoGif = styled.video``
